<!-- Main app content with smooth initialization -->
<div [class.initialized]="isInitialized" [style.opacity]="isInitialized ? 1 : 0" style="transition: opacity 0.3s ease-in-out;">
  <app-layout>
    <div *ngIf="navigationErrorUrl" class="mx-auto mt-4 flex max-w-5xl flex-col gap-3 rounded-xl border border-red-200 bg-red-50 p-4 text-sm text-red-900 sm:flex-row sm:items-center sm:justify-between"
      role="alert" aria-live="assertive">
      <p>{{ 'Nie udało się otworzyć tej strony. Spróbuj ponownie lub wróć na stronę główną.' | translate }}</p>
      <div class="flex shrink-0 gap-3">
        <button type="button" (click)="retryFailedNavigation()"
          class="font-semibold underline underline-offset-2">{{ 'Spróbuj ponownie' | translate }}</button>
        <a routerLink="/" class="font-semibold underline underline-offset-2">{{ 'Strona główna' | translate }}</a>
      </div>
    </div>
    <router-outlet></router-outlet>
  </app-layout>

  <!-- Cookie Consent Banner -->
  <app-cookie-consent></app-cookie-consent>
</div>

<button *ngIf="showBackToTop" type="button" class="back-to-top-button" [attr.aria-label]="'Wróć na górę strony' | translate"
  [title]="'Wróć na górę strony' | translate" (click)="scrollToTop()">
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.4" />
    <path d="M12 17V7m-4 4 4-4 4 4" stroke="currentColor" stroke-width="1.6"
      stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</button>
